/* eslint-disable no-useless-concat */
import {
  formatSqlDateTimeParen,
  formatTime,
  parseBackendDateTimeParts,
} from './formatDate';
import { obterNomeDoMes } from './obterNomeDoMes';

function getUser(item) {
  return item.user ? `${item.user.username}` : '-';
}

function getObs(item) {
  return item?.obs;
}

function getChangeIn(item) {
  return item?.change_in;
}

function getChangeTo(item) {
  return item?.change_to;
}

function getDesc(item) {
  return item?.desc;
}

function getTimelineUserDescription(item) {
  return `[ ${getUser(item)} ] ${formatSqlDateTimeParen(item?.created_at)}  `;
}

function getNewTimeLineV2Hours(item) {
  return formatTime(item?.created_at);
}

function getNewTimeLineV2Date(item) {
  const p = parseBackendDateTimeParts(item?.created_at);
  if (!p) return '';
  const monthNum = parseInt(p.month, 10);
  return `${obterNomeDoMes(monthNum)} ${p.day}`;
}

function getOccurencesDate(value) {
  const p = parseBackendDateTimeParts(value);
  if (!p) return '';
  const monthNum = parseInt(p.month, 10);
  return `${obterNomeDoMes(monthNum)} ${p.day}`;
}

function getOccurencesTime(value) {
  return formatSqlDateTimeParen(value);
}

function getNewTimeLineV2FullDateAndTime(item) {
  const p = parseBackendDateTimeParts(item?.created_at);
  if (!p) return '';
  return `${p.day}/${p.month}/${p.year} - ${p.hours}:${p.minutes}:${p.seconds}`;
}

function getTimelineDescription(item) {
  return `${getDesc(item)}`;
}

const formatCustomDate = (dataString) => {
  if (!dataString) return '';

  const p = parseBackendDateTimeParts(String(dataString));
  if (!p) return '';

  return `${p.day}/${p.month}/${p.year} - ${p.hours}:${p.minutes}`;
};

export {
  getTimelineUserDescription,
  getTimelineDescription,
  getObs,
  getChangeIn,
  getChangeTo,
  getUser,
  getDesc,
  getNewTimeLineV2Hours,
  getNewTimeLineV2Date,
  getNewTimeLineV2FullDateAndTime,
  getOccurencesDate,
  getOccurencesTime,
  formatCustomDate,
};
